<template>
  <RouterLink
    class="navigation-main-links d-flex align-items-center text-decoration-none"
    active-class="active"
    :to="{ name: linkInfo.route }"
  >
    <i :class="`bi ${linkInfo.icon} text-center`"></i>

    {{ linkInfo.name }}
  </RouterLink>
</template>

<script lang="ts" setup>
import { type NavigationLink } from '@/components/navigation/constants/NAVIGATION';

type Props = {
  linkInfo: NavigationLink;
};

defineProps<Props>();
</script>

<style lang="scss" scoped>
/* Links */
.navigation-main-links {
  gap: 0.875rem;
  padding: 0.5rem 1rem;
  margin-bottom: 0.35rem;
  border-radius: 0.625rem;
  color: #b7c0ce;
  transition: all 0.25s ease;
  font-size: 0.8125rem;
}

.navigation-main-links i {
  width: 1.375rem;
  font-size: 1.1rem;
  opacity: 0.85;
}

.navigation-main-links span {
  flex: 1;
}

/* Hover */
.navigation-main-links:hover {
  color: white;
  background: rgba(255, 255, 255, 0.05);
  transform: translateX(0.1875rem);
}

/* Active */
.navigation-main-links.router-link-active,
.navigation-main-links.active {
  color: white;
  background: linear-gradient(90deg, #9c314d, #702640);
  box-shadow: 0 0.625rem 1.375rem rgba(156, 49, 77, 0.35);
}

.navigation-main-links.router-link-active i {
  opacity: 1;
}
</style>
